import { StyleSheet } from 'react-native'
import type { EdgeInsets } from 'react-native-safe-area-context'
import type { Theme } from '../../src/theme/getTheme'

export const getScreenLayoutStyles = (theme: Theme, insets: EdgeInsets) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    header: {
      paddingHorizontal: 16,
      paddingTop: insets.top + 4,
      paddingBottom: 8,
    },
  })
